import {
  MessageSquare,
  MapPin,
  PencilRuler,
  HardHat,
  CheckCircle2,
  LifeBuoy,
} from "lucide-react";

const STEPS = [
  { id: "consultation", n: "01", title: "Consultation", desc: "Understanding your needs & goals.", icon: MessageSquare },
  { id: "site-survey", n: "02", title: "Site Survey", desc: "Roof, shading & load assessment.", icon: MapPin },
  { id: "design", n: "03", title: "System Design", desc: "Custom-engineered for your home.", icon: PencilRuler },
  { id: "installation", n: "04", title: "Installation", desc: "Safe, certified expert install.", icon: HardHat },
  { id: "testing", n: "05", title: "Testing & Commissioning", desc: "Full QC and grid sync.", icon: CheckCircle2 },
  { id: "support", n: "06", title: "Ongoing Support", desc: "Maintenance & monitoring.", icon: LifeBuoy },
];

export const Process = () => {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="relative py-20 lg:py-28 bg-[#F8FAFC] overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="chapter-label tt-reveal" data-testid="process-chapter-label"><span>04 / THE WAY FORWARD</span><span>FROM FIRST HELLO TO FIRST KILOWATT</span></div>
        <div className="section-intro tt-reveal"><div><h2 className="eyebrow" data-testid="process-heading">OUR WORK PROCESS</h2><p className="section-statement" data-testid="process-statement">A clear path.<br /><span>A brighter future.</span></p></div><p>Six considered steps. One dedicated team. We take care of the details, so you can enjoy the sunshine.</p></div>

        {/* Desktop horizontal */}
        <div className="hidden lg:block relative">
          <div className="absolute top-12 left-[7%] right-[7%] tt-dashed h-[2px]" />
          <div className="grid grid-cols-6 gap-3 relative">
            {STEPS.map((s, idx) => {
              const Icon = s.icon;
              return (
                <div
                  key={s.id}
                  data-testid={`process-step-${s.id}`}
                  className="tt-reveal flex flex-col items-center text-center group"
                  style={{ transitionDelay: `${idx * 80}ms` }}
                >
                  <div className="relative">
                    <div className="w-24 h-24 rounded-full bg-white border-2 border-slate-200 flex items-center justify-center shadow-[0_10px_30px_rgba(15,76,129,0.06)] group-hover:border-[#F6B800] group-hover:scale-105 transition-all duration-300">
                      <Icon className="w-9 h-9 text-[#0F4C81] group-hover:text-[#0F4C81]" strokeWidth={2} />
                    </div>
                    <div className="absolute -top-2 -right-2 w-9 h-9 rounded-full bg-[#F6B800] text-[#0F4C81] font-display font-bold text-sm flex items-center justify-center shadow-md">
                      {s.n}
                    </div>
                  </div>
                  <h3 className="font-display font-semibold text-slate-900 mt-5 text-[16px]">{s.title}</h3>
                  <p className="text-slate-500 text-sm mt-1.5 max-w-[160px] leading-relaxed">{s.desc}</p>
                </div>
              );
            })}
          </div>
        </div>

        {/* Mobile/tablet vertical */}
        <div className="lg:hidden relative">
          <div className="absolute left-[42px] top-2 bottom-2 w-[2px] tt-dashed" />
          <div className="space-y-6">
            {STEPS.map((s, idx) => {
              const Icon = s.icon;
              return (
                <div
                  key={s.id}
                  data-testid={`process-step-mobile-${s.id}`}
                  className="tt-reveal flex gap-5 items-start"
                  style={{ transitionDelay: `${idx * 60}ms` }}
                >
                  <div className="relative flex-shrink-0">
                    <div className="w-[88px] h-[88px] rounded-full bg-white border-2 border-slate-200 flex items-center justify-center shadow-md">
                      <Icon className="w-8 h-8 text-[#0F4C81]" strokeWidth={2} />
                    </div>
                    <div className="absolute -top-1 -right-1 w-8 h-8 rounded-full bg-[#F6B800] text-[#0F4C81] font-bold text-xs flex items-center justify-center">
                      {s.n}
                    </div>
                  </div>
                  <div className="pt-3">
                    <h3 className="font-display font-semibold text-slate-900 text-lg">{s.title}</h3>
                    <p className="text-slate-500 text-sm mt-1.5">{s.desc}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};
